import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { API_CONFIG } from "../config/config";
import AppNavbarCable from "./../components/Navbars/Navbar-cable";
import "../../src/assets/css/profileIcon.css"; // same CSS as first code

const stripePromise = loadStripe(
  "pk_test_51JfReLJPZeaWJFtowo0oeAGU77RAewHmkNRiOwq6efSz8tUGOvOuzi25F98jBg8yPafQcavQlMLHPfCma5sSde9o00hWKmY2lH"
);

class CableRent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: null,
      deviceId: localStorage.getItem("deviceId"),
      showAdModal: false,
      showFirstAd: false,
      showSecondAd: false,
      sessionId: null,
    };
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const param = new URLSearchParams(window.location.search);
    localStorage.setItem("deviceId", param.get("deviceId"));

    let cableDeviceId = params.deviceId;
    this.setState({
      deviceId: cableDeviceId,
    });
    const deviceId = localStorage.getItem("deviceId");
    if (deviceId !== null) {
      console.log("Found device id : ", deviceId);
      axios(`${API_CONFIG.HOST}/cable-store/${deviceId}/precheck`, {
        headers: {
          Authorization: `${API_CONFIG.AUTH_KEY}`,
        },
      })
        .then((response) => {
          console.log("status code ", response.status);
          if (response.data) {
            axios(`${API_CONFIG.HOST}/cable/${deviceId}/active-session`, {
              headers: {
                Authorization: `${API_CONFIG.AUTH_KEY}`,
              },
            })
              .then((response) => {
                console.log("status code 2", response.status);
                if (response.data.sessionActive) {
                  localStorage.setItem("passcode", response.data.passCode);
                  //return history.push('/passcode');
                  this.props.history.push("/passcode");
                  //return navigate('/passcode');
                }
              })
              .catch((error) => {
                console.log("status code 3 ", error.response.status);
                if (error.response && error.response.status === 400) {
                  this.props.history.push("/");
                  //return history.push('/');
                }
              });
          } else {
            this.props.history.push("/onboard");
          }
        })
        .catch((error) => {
          console.log("status code 4", error.response.status);

          //     console.log("status code 2",error.response.status);
          //     if (error.response && error.response.status === 400) {
          //       this.props.history.push('/');
          //       //return history.push('/');
          // }
        });
    }
    //const navigate = useNavigate();
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownVisible: !prevState.isDropdownVisible,
    }));
  };

  selectPlan = (plan) => {
    this.setState({ selectedPlan: plan });
    if (plan === "Plan B") {
      sessionStorage.setItem("durationInHour", 1);
    }
  };

  handleStripeClick = async (e) => {
    e.preventDefault();
    const { selectedPlan, deviceId } = this.state;

    if (selectedPlan !== "Plan B") {
      alert("Please select Plan B to proceed with payment.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_CONFIG.HOST}/stripe/create-checkout-session`,
        {
          plan: selectedPlan,
          amount: 1,
          currency: "eur",
          deviceId,
        },
        {
          headers: { Authorization: API_CONFIG.AUTH_KEY },
        }
      );

      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: response.data.sessionId });
    } catch (error) {
      console.error("Stripe session error:", error);
      alert("Payment initiation failed.");
    }
  };

  handleAdClick = async () => {
    const { deviceId } = this.state;
    let sessionId =
      localStorage.getItem("sessionId") || sessionStorage.getItem("sessionId");
    let createdAt =
      localStorage.getItem("createdAt") || sessionStorage.getItem("createdAt");

    // If session does not exist, create new session ID and mark first ad
    if (!sessionId) {
      sessionId = Math.random()
        .toString(36)
        .substring(2, 12);
      createdAt = new Date().toISOString();

      localStorage.setItem("sessionId", sessionId);
      localStorage.setItem("createdAt", createdAt);
      sessionStorage.setItem("sessionId", sessionId);
      sessionStorage.setItem("createdAt", createdAt);

      this.setState({
        sessionId,
        createdAt,
        selectedPlan: "AdBased",
        showAdModal: true,
        showFirstAd: true,
        showSecondAd: false,
      });

      return;
    }

    // since Session exists — check backend for session details
    this.setState({ sessionId, selectedPlan: "AdBased" });

    try {
      const res = await axios.get(
        `${API_CONFIG.HOST}/cable/get-session-details/:sessionId`,
        {
          headers: { Authorization: API_CONFIG.AUTH_KEY },
        }
      );

      const sessionData = res.data;
      //   createdAt = new Date(sessionData.lastSuccessfullyUsed || sessionData.timestamp).toISOString();
      //   localStorage.setItem('createdAt', createdAt);

      const startNew = sessionData.startNew === true;

      this.setState({
        showAdModal: true,
        showFirstAd: startNew,
        showSecondAd: !startNew,
      });
    } catch (err) {
      console.error("Error checking ad session:", err);
      alert("Unable to start ad session.");
    }
  };

  handleAdEnded = async () => {
    const { deviceId, sessionId, showFirstAd } = this.state;
    const durationInHour = showFirstAd ? 1 : 2;
    const timestamp = new Date().toISOString();

    try {
      // 🔹 Commented out: Send session info to backend
      /*
    await axios.post(`${API_CONFIG.HOST}/logSession`, {
      sessionId,
      timestamp,
      durationInHour
    }, {
      headers: { Authorization: API_CONFIG.AUTH_KEY }
    });
    */

      // 🔹 Fetch passcode
      let deviceId = localStorage.getItem("deviceId");

      const res = await axios.get(
        `${API_CONFIG.HOST}/cable/${deviceId}/${durationInHour}/${sessionId}`,
        {
          headers: { Authorization: API_CONFIG.AUTH_KEY },
        }
      );

      if (res.data.passCode) {
        localStorage.setItem("passcode", res.data.passCode);
        this.setState({ showAdModal: false }, () => {
          this.props.history.push(`/passcode?session_id=${sessionId}`);
        });
      }

      /*
 function generatePasscode() {
      return Math.floor(100000 + Math.random() * 900000).toString();
    }

    // 🔹 Generate the passcode
    const passcode = generatePasscode();

    // 🔹 Store the passcode in localStorage
    localStorage.setItem("passcode", passcode);

    // 🔹 Log it to the console
    console.log("Generated Passcode:", passcode);
    this.setState({ showAdModal: false }, () => {
      this.props.history.push(`/passcode?session_id=${sessionId}`);
    })
    */
    } catch (err) {
      console.error("Error after ad ended:", err);
      alert("Something went wrong after the ad.");
      this.setState({ showAdModal: false });
    }
  };

  render() {
    const { selectedPlan, showAdModal, showFirstAd, showSecondAd } = this.state;

    return (
      <div className="content2">
        <AppNavbarCable {...this.props} />
        <Container>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" onSubmit={this.handleStripeClick}>
              <div className="logo-container">
                <div style={{ textAlign: "center", marginTop: "10%" }}>
                  <img
                    src="./Plugo-Logo-New-Blue.png"
                    style={{ height: "20%" }}
                    alt="Logo"
                  />
                  <div style={{ marginTop: "20px" }}>
                    <h4 style={{ padding: "4px 4px" }}>SCAN AND CHARGE</h4>
                  </div>
                </div>
              </div>
              <div className="login-form">
                <Card className="login-card">
                  <CardBody>
                    <FormGroup>
                      <label>Select Plan *</label>
                      <div className="card-container">
                        <Card
                          onClick={() => this.selectPlan("Plan B")}
                          className={`plan-card ${
                            selectedPlan === "Plan B" ? "selected" : ""
                          }`}
                        >
                          <CardBody>
                            <h6>Economy Plan</h6>
                            <p>20 minutes</p>
                            <p>€1</p>
                          </CardBody>
                        </Card>
                        <Card
                          onClick={this.handleAdClick}
                          className={`plan-card ${
                            selectedPlan === "AdBased" ? "selected" : ""
                          }`}
                        >
                          <CardBody>
                            <h6>Watch Ad</h6>
                            <p>30s / 60s video</p>
                            <p>Get code for free</p>
                          </CardBody>
                        </Card>
                      </div>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    <FormGroup>
                      <Button
                        type="submit"
                        block
                        color="success"
                        size="lg"
                        disabled={!selectedPlan}
                      >
                        Proceed
                      </Button>
                    </FormGroup>
                  </CardFooter>
                </Card>
              </div>
            </Form>
          </Col>
        </Container>

        {/* Ad Modal */}
        <Modal isOpen={showAdModal} centered backdrop="static">
          <ModalHeader>Watch Ad to Continue</ModalHeader>
          <ModalBody>
            {!showFirstAd && !showSecondAd && (
              <div className="text-center">
                <p>Loading ad...</p>
                <div className="spinner-border text-primary" role="status" />
              </div>
            )}
            {showFirstAd && (
              <video width="100%" autoPlay onEnded={this.handleAdEnded}>
                <source
                  src="https://static.videezy.com/system/resources/previews/000/014/044/original/30_seconds_digital_clock_display_of_seven_segments.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            )}

            {showSecondAd && (
              <video width="100%" autoPlay onEnded={this.handleAdEnded}>
                <source
                  src="https://static.videezy.com/system/resources/previews/000/050/945/original/Countdown_30-FPS_4k.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default withRouter(CableRent);
